import { KampaayDataProvider } from 'services/api/dataProvider'
import { APIMember } from 'services/api/entities/crm/organizations/types/api/response-models'
import { Organization } from 'services/api/entities/crm/organizations/types/internal/organization-model'
import { getDateAsString } from 'services/utils/date'
import { EntityDescriptor } from '.'

const formatMember = (member: APIMember) => {
  const { userName, role, budget, budgetDueDate } = member
  return {
    'User Email': userName,
    Role: role,
    Budget: budget,
    'Due Date': getDateAsString(budgetDueDate),
  }
}

const formatOrganization =
  (_dataProvider?: KampaayDataProvider) => (org: Organization) => {
    const { name, members } = org
    return {
      'Organization Name': name,
      members: members.map(formatMember),
    }
  }

export const organization: EntityDescriptor<Organization> = {
  format: formatOrganization,
}
